import type { GameItem } from "@/lib/types";
import GameCard from "./GameCard";

interface Props {
  games: GameItem[];
}

// 게임 카드 묶음. 개수를 고정하지 않고 서버가 준 만큼만 그린다.
// 모바일 2열 → 태블릿 3열 → 데스크톱 6열 (게임이 늘면 자연스럽게 다음 줄로 흐른다).
export default function GamesGrid({ games }: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {games.map((g) => (
        <GameCard key={g.code} game={g} />
      ))}
    </div>
  );
}